import { render, staticRenderFns } from "./coLevelAction.vue?vue&type=template&id=2dcd2432&scoped=true"
import script from "./coLevelAction.vue?vue&type=script&lang=js"
export * from "./coLevelAction.vue?vue&type=script&lang=js"
import style0 from "./coLevelAction.vue?vue&type=style&index=0&id=2dcd2432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd2432",
  null
  
)

export default component.exports